/* eslint-disable */
export default {
  downloadSuccess: 'Registo transferido.',
  downloadFail: 'A transferência do registo de erros falhou. Tente novamente.',
} as const;

// @key: @#@"downloadSuccess"@#@ @source: @#@"Log downloaded."@#@
// @key: @#@"downloadFail"@#@ @source: @#@"Error log download failed. Please try again."@#@
